import styled from 'styled-components'
import { BaseText } from 'components/common/text'
import { Tag } from 'components/common/tag'

export const AssessmentDescText = styled(BaseText)`
  line-height: 24px;
`

export const ProfileItemTag = styled(Tag)`
  background: none;
`

export const ProfileItemTitleText = styled(BaseText)`
  line-height: 29px;
  white-space: nowrap;
  color: #777a88;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: 14px;
  }
`

export const ProfileItemSubText = styled(BaseText)`
  color: ${(p) => p.theme.color.gray2};
  line-height: 29px;
  white-space: nowrap;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: 14px;
  }
`
